import React from 'react';
import {
  CANCEL_BTN,
  CREATE_WORKFLOW_TYPE_TITLE,
  DRAWER_WIDTH,
  EDIT_WORKFLOW_TYPE_TITLE,
  SAVE_BTN,
  UPDATE_BTN,
} from '@moxie/constants';
import { Space } from 'antd';
import { Button, DrawerElem } from '@moxie/shared';
import { IWorkflowTypeDrawerComponent } from '@shared-components/models';
import { WorkflowTypeForm } from '../../forms';

const WorkflowTypeDrawer: React.FC<IWorkflowTypeDrawerComponent> = ({
  visible,
  onClose,
  form,
  disabled,
  setDisabled,
  handleFormSubmit,
  handleSubmit,
  isEdit,
  submitted,
}: IWorkflowTypeDrawerComponent) => {
  return (
    <DrawerElem
      title={isEdit ? EDIT_WORKFLOW_TYPE_TITLE : CREATE_WORKFLOW_TYPE_TITLE}
      width={DRAWER_WIDTH}
      visible={visible}
      onClose={onClose}
      footer={
        <div className="padding-bottom-2 text-align-right">
          <Space direction="horizontal">
            <Button onClick={onClose} className="lead-margin-right">
              {CANCEL_BTN}
            </Button>
            <Button
              type="primary"
              onClick={handleFormSubmit}
              disabled={disabled}
            >
              {isEdit ? UPDATE_BTN : SAVE_BTN}
            </Button>
          </Space>
        </div>
      }
    >
      <WorkflowTypeForm
        form={form}
        onSubmit={handleSubmit}
        setDisabled={setDisabled}
        submitted={submitted}
        isEdit={isEdit}
      />
    </DrawerElem>
  );
};

export { WorkflowTypeDrawer };
